import React from "react";
import {
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    Stack,
    Typography,
    Box,
} from "@mui/material";
import {removeSessionOperator} from "../../helper/session";
import {offlineDB} from "../../store/offlineDb";
import {PATH_AUTH} from "../../routes/path";
import {useNavigate} from "react-router-dom";
import {useAuthContext} from "../../auth/useAuthContext";

export default function LicenseExpiredDialog({ open }) {
    const navigate = useNavigate();
    const {logout} = useAuthContext();

    const handleLogout = async () => {
        try {
            removeSessionOperator()
            await Promise.all(offlineDB.tables.map(table => table.clear()));
            logout()
            navigate(PATH_AUTH.login, {replace: true});
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <Dialog open={open} fullWidth maxWidth="sm">
            <DialogTitle>
                <Stack alignItems="center" spacing={1}>
                    <Typography variant="h6" fontWeight="bold">
                        Bussoft – Obaveštenje
                    </Typography>
                </Stack>
            </DialogTitle>

            <DialogContent>
                <Box textAlign="center" mb={2}>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                        Vaša licenca je trenutno <strong>neaktivna zbog neplaćanja</strong>.
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                        Molimo Vas da kontaktirate svog distributera radi nastavka korišćenja sistema.
                    </Typography>
                </Box>
            </DialogContent>

            <Stack sx={{p: 1, justifyContent: 'center', alignItems: 'center'}}>
                <Button onClick={handleLogout} variant="outlined" color="primary" sx={{width: 200}}>
                    Potvrdi
                </Button>
            </Stack>

        </Dialog>
    );
}
